import { ReactElement } from 'react';

export interface IModalFooterProps {
    content: ReactElement;
    showDivider?: boolean;
}

export default function ModalFooter(props: IModalFooterProps) {
    const { content, showDivider = true } = props;
    const borderClass = showDivider
        ? 'border border-solid border-b-0 border-r-0 border-l-0 border-[var(--nj-core-color-grey-300)]'
        : 'border-0';
    return (
        <div
            className={`nj-modal__footer py-[var(--nj-semantic-size-spacing-16)] px-[var(--nj-semantic-size-spacing-24)] ${borderClass}`}
        >
            {content}
        </div>
    );
}
